const buildForCustomers = true;
let path = "";
switch (process.env.NODE_ENV){
  case "development":
    path = process.env["VUE_APP_PATH"]
    break;
  case "production":
    if(buildForCustomers){
      path = process.env["VUE_APP_PATH"]
    }else{
      path = "/ringv2"
    }
    break;
  default:
    break;
}

export const PATH_HANDLER = {
  path
}
